var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmployee(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    stroke: "#5E5E66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M7.66875 8.81354C7.09484 8.1349 6.7162 7.33353 6.71603 6.41422C6.71803 5.42219 7.07949 4.48353 7.7031 3.80089C8.32449 3.12068 9.1514 2.75208 9.99818 2.75C10.8451 2.75162 11.6724 3.12 12.294 3.80025C12.9179 4.48297 13.2795 5.42195 13.2813 6.41429C13.2811 7.33433 12.9043 8.1347 12.3295 8.8127C11.9805 9.22432 12.0943 9.8633 12.584 10.1196C14.8698 11.3159 16.8706 13.9221 17.2019 17.0797C17.206 17.1189 17.1951 17.1527 17.1636 17.1852C17.129 17.221 17.0718 17.25 17 17.25H3C2.92823 17.25 2.87101 17.221 2.83637 17.1852C2.80496 17.1527 2.79402 17.119 2.79813 17.0798C3.12969 13.9213 5.13273 11.3157 7.41419 10.1193C7.903 9.86292 8.01677 9.22506 7.66875 8.81354Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.75727620.svg";
export { ForwardRef as ReactComponent };